import { Component, Input, OnInit } from '@angular/core';
import { IMessage } from '../../api/interfaces/Messages';
import { MessageType } from '../../api/model/message/message-type.model';

@Component({
  selector: 'alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent {
  @Input() translations;
  messageContent: string;
  _message: IMessage;

  @Input() set message (message) {
    this._message = message;
    if (!message) {
      return;
    }
    if (message.key) {
      this.messageContent = this.translations[message.key] || message.key;
    } else {
      this.messageContent = message.text;
    }
  }

  get message(): IMessage {
    return this._message;
  }

  isWarning() {
    return !this.message.messageType || MessageType.isWarning(this.message.messageType);
  }
  isSuccess() {
    return MessageType.isSuccess(this.message.messageType);
  }
  isError() {
    return MessageType.isError(this.message.messageType);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/alert-message/alert-message.component.ts